var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],ref:"headerContainer",attrs:{"id":"header_container"}})}
var staticRenderFns = []

export { render, staticRenderFns }